/* eslint-disable i18next/no-literal-string */
const WebPayLogo = (
    props: React.ImgHTMLAttributes<HTMLImageElement>
): React.ReactElement => {
    return <img src="/web-pay-logo.webp" alt="web-pay-logo" {...props} />
}

export default WebPayLogo
